// extracted by mini-css-extract-plugin
export default {"shrink":"LogoLoadingSpinner_shrink__5ZFYG","grow":"LogoLoadingSpinner_grow__LoELf","bounce":"LogoLoadingSpinner_bounce__TLRxZ","max":"LogoLoadingSpinner_max__gcF0z"};